module.exports = __webpack_public_path__ + "img/banner_zhuyi.e4be171d.png";